<template>
  <el-dialog :visible.sync="visible" title="客户面单流水查询" width="1000px" :close-on-click-modal="false">
    <el-form size="mini" :inline="true">
      <el-form-item label="时间">
        <yto-date-picker
          :maxRangeVal="31"
          :clearable="false"
          :editable="false"
          :picker-options="pickerOptions"
          v-model="searchForm.queryDate"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy.MM.dd HH:mm">
        </yto-date-picker>
      </el-form-item>
      <el-form-item label="客户编码">
        <el-select @change="changeK" v-model="searchForm.customerCode">
          <el-option
            v-for="(item, idx) in kList"
            :key="idx"
            :label="item.code + '-' + item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值平台">
        <el-select v-model="searchForm.channel" @change="changePlat">
          <el-option
            v-for="(item, idx) in curPlatList"
            :key="idx"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值服务">
        <el-select v-model="searchForm.segmentCode">
          <el-option label="普通" value="NORMAL"></el-option>
          <el-option label="COD" value="SVC-COD" v-if="showCOD"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户/商家">
        <el-select v-model="searchForm.sellerId">
          <template v-if="searchForm.channel === 'YTO'">
            <el-option :label="curKInfo.code + '-' + curKInfo.name" :value="curKInfo.code"></el-option>
          </template>
          <template v-else>
            <el-option v-for="(item, idx) in shopList" :key="idx" :label="item.shopName" :value="item.shopId"></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="y-mb-10">
      <el-tooltip placement="right" effect="light">
        <div slot="content">
          <div>（1）查询期初库存：期初日期之前的面单余额</div>
          <div>（2）期初库存时间：查询开始时间最后一次余额变动时间</div>
          <div>（3）充值量：查询时间内，通过自助充值、或者您合作的网点人工充值、自动充值的电子面单总量</div>
          <div>（4）撤销量：查实时数据</div>
          <div>（5）解冻量：您在合作网点的账户不欠费或者账户余额高于预警值后，冻结的面单会自动解冻并充值回去</div>
          <div>（6）查询期末库存：期末库存=期初库存+充值量+回收量+解冻量-使用量-撤销量-回收再使用量（补扣）-二次回收扣除量（客户管家补扣）-冻结量</div>
          <div>（7）查询期末库存时间：查询结束时间当天最后一次面单余额变动时间</div>
        </div>
        <i class="el-icon-warning y-fc-4C84FF"></i>
      </el-tooltip>
      <span class="y-fs-12 y-ml-5 y-f-b">面单流水字段说明</span>
    </div>
    <el-table border :data="tableData" v-loading="loading">
      <el-table-column label="客户编码" property="customerCode"></el-table-column>
      <el-table-column label="客户名称" property="customerName"></el-table-column>
      <el-table-column label="面单类型" property="channelName"></el-table-column>
      <el-table-column label="店铺名称" property="sellerName"></el-table-column>
      <el-table-column label="查询期初库存时间" property="startTime"></el-table-column>
      <el-table-column label="查询期初库存" property="startQuantity"></el-table-column>
      <el-table-column label="充值量">
        <template slot-scope="scope">
          <span v-if="scope.row.rechargeQuantity <= 0">{{ scope.row.rechargeQuantity }}</span>
          <el-button @click="getDetail(scope.row, 'rechargeQuantity')" v-else type="text">{{ scope.row.rechargeQuantity }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="使用量" property="useQuantity"></el-table-column>
      <el-table-column label="回收量">
        <template slot-scope="scope">
          <span v-if="scope.row.recycleQuantity <= 0">{{ scope.row.recycleQuantity }}</span>
          <el-button @click="getDetail(scope.row, 'recycleQuantity')" v-else type="text">{{ scope.row.recycleQuantity }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="回收再使用量（补扣）">
        <template slot-scope="scope">
          <span v-if="scope.row.recycleReUseQuantity <= 0">{{ scope.row.recycleReUseQuantity }}</span>
          <el-button @click="getDetail(scope.row, 'recycleReUseQuantity')" v-else type="text">{{ scope.row.recycleReUseQuantity }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="二次回收扣除量（客户管家补扣）">
        <template slot-scope="scope">
          <span v-if="scope.row.secondRecycleQuantity <= 0">{{ scope.row.secondRecycleQuantity }}</span>
          <el-button @click="getDetail(scope.row, 'secondRecycleQuantity')" v-else type="text">{{ scope.row.secondRecycleQuantity }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="撤销量">
        <template slot-scope="scope">
          <span v-if="scope.row.revokeQuantity <= 0">{{ scope.row.revokeQuantity }}</span>
          <el-button @click="getDetail(scope.row, 'revokeQuantity')" v-else type="text">{{ scope.row.revokeQuantity }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="冻结量" property="freezeQuantity"></el-table-column>
      <el-table-column label="解冻量" property="unFreezeQuantity"></el-table-column>
      <el-table-column label="查询期末库存" property="quantity"></el-table-column>
      <el-table-column label="查询期末库存时间" property="modifyTime"></el-table-column>
    </el-table>
    <detailDialog
      :curRowInfo="curRowInfo"
      :queryDate="searchForm.queryDate"
      :fromParentVisible.sync="showDetail"
      v-if="showDetail"
      :detailType="detailType"
    />
    <div slot="footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { dateFormat, YTOSHORTCUTSNo } from '@/utils/util'
import { getCustomCodeBalanceApi, querySellerFlowingApi, selectPlatformApi, selectShopByConditionApi } from '@/api/baseInfo/printSetting/faceBillBalanceSearch';
export default {
  components: {
    detailDialog: () => import('./detailDialog.vue')
  },
  data() {
    return {
      loading: false,
      showDetail: false,
      visible: true,
      pickerOptions: {
        ...YTOSHORTCUTSNo,
        disabledDate(time) {
          return (
            time.getTime() > new Date(`${dateFormat(new Date(), 'yyyy-MM-dd')} 23:59:59`).getTime() ||
            time.getTime() < new Date(new Date().getTime() - 89 * 24 * 3600 * 1000).getTime()
          );
        }
      },
      kList: [], // 客户编码列表
      searchForm: {
        queryDate: [],
        customerCode: '',
        channel: '', // 充值平台
        segmentCode: 'NORMAL', // 充值服务
        sellerId: '', // 店铺
      },
      curPlatList: [], // 当前平台列表
      curKInfo: {}, // 当前选中的k码信息
      kplatMapCache: {}, // k码对应的平台缓存
      showCOD: false, // 是否显示COD服务
      shopList: [],
      tableData: [],
      curPlatinfo: {},
      detailType: '',
      curRowInfo: {}
    }
  },
  mounted() {
    this.initTime();
    this.getKList();
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  methods: {
    handleReset() {
      // 重置
      this.initTime();
      this.searchForm.customerCode = '';
      this.searchForm.channel = '';
      this.searchForm.segmentCode = 'NORMAL';
      this.searchForm.sellerId = '';
      this.tableData = [];
    },
    getDetail(row, type) {
      // 查看详情
      this.curRowInfo = row;
      this.detailType = type;
      this.showDetail = true;
    },
    handleSearch() {
      if(!this.searchForm.customerCode) {
        this.$message.error('请选择客户编码');
        return;
      }
      if(!this.searchForm.channel) {
        this.$message.error('请选择充值平台');
        return;
      }
      if(!this.searchForm.sellerId) {
        this.$message.error('请选择客户/商家');
        return;
      }
      let params = {
        customerCode: this.searchForm.customerCode,
        customerName: this.curKInfo.name,
        startTime: this.searchForm.queryDate[0],
        endTime: this.searchForm.queryDate[1],
        channel: this.searchForm.channel,
        sellerId: this.searchForm.sellerId,
        segmentCode: this.searchForm.segmentCode
      }
      this.loading = true;
      querySellerFlowingApi(params).then(res => {
        this.loading = false;
        if(res.data) {
          this.tableData = [res.data]
        } else {
          this.tableData = [];
        }
      }).catch(() => {
        this.loading = false;
        this.tableData = [];
      })
    },
    changePlat(val) {
      this.curPlatinfo = this.curPlatList.find(item => item.code === val);
      this.showCOD = this.curPlatinfo.isCod === 'Y' ? true : false;
      this.searchForm.segmentCode = 'NORMAL';
      if(val !== 'YTO') {
        let params = {
          kcode: this.searchForm.customerCode,
          platform: val,
          loginId: this.userMess.loginId,
          groupId: this.userMess.groupId
        }
        // 获取店铺
        selectShopByConditionApi(params).then(res=> {
          if(res.success) {
            this.shopList = res.data.shopList ? res.data.shopList : [];
            this.searchForm.sellerId = this.shopList[0].shopId;
          }else {
            this.$message.error(res.message);
          }
        }).catch((err) => {
          this.$message.error(err.error);
        });
      } else {
        // 圆通普通面单
        this.searchForm.sellerId = this.curKInfo.code;
      }
    },
    changeK(val) {
      // 改变了客户编码 则需要展示对应的平台
      this.curKInfo = this.kList.find(item => item.code === val);
      if(!this.kplatMapCache[val]) {
        // 没有值 则调接口
        this.selectPlatform(val);
      } else {
        this.curPlatList = this.kplatMapCache[val];
      }
    },
    initTime() {
      let currentDate = new Date();
      let before7Day = currentDate.setDate(currentDate.getDate() - 6);
      this.searchForm.queryDate = [
        dateFormat(new Date(before7Day), 'yyyy-MM-dd') + ' 00:00:00',
        dateFormat(new Date(new Date()), 'yyyy-MM-dd') + ' 23:59:59'
      ];
    },
    // 查看平台
    selectPlatform(kcode) {
      let params = {
        kcode,
        loginId: this.userMess.loginId,
        groupId: this.userMess.groupId
      }
      selectPlatformApi(params).then(res=> {
        if(res.success){
          this.$set(this.kplatMapCache, kcode, res.data.platformList ? res.data.platformList : []);
          this.curPlatList = this.kplatMapCache[kcode];
          this.searchForm.channel = this.curPlatList[0].code;
          this.changePlat(this.searchForm.channel);
        }else{
          this.$message.error(res.message);
          this.curPlatList = [];
        }
      }).catch((err) => {
        this.$message.error(err.error);
        this.curPlatList = [];
      });
    },
    getKList() {
      getCustomCodeBalanceApi().then(res => {
        if (res.message === 'ok') {
          this.kList = res.data || [];
        } else {
          this.kList = [];
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.kList = [];
        this.$message.error(err.error);
      })
    },
  },
  watch: {
    visible(val) {
      this.$emit('update:fromParentVisible', val)
    }
  }
}
</script>
